$(function () {
  // カートに商品の追加
  $('.cart-add-btn').on('click', function (event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    // 画面上のエラーメッセージを削除
    $('p.append_msg').remove();
    np_jp.removeHasError();

    // 問診票、または医療従事者向けの場合、確認ダイアログを表示
    let item_prefix = $(this).data('dialog-prefix');
    let item_code = $(this).data('dialog-code');
    let item_branch = $(this).data('dialog-branch');
    let url = location.origin
      + '/item/detail?item_prefix=' + item_prefix
      + '&item_code=' + item_code
      + '&item_branch=' + item_branch;
    let medicalqa_flg = $(this).data('medicalqa-class');
    let medical_flg = $(this).data('dialog-medical-flg');

    if (medicalqa_flg === 1) {
      let link = document.getElementById('medicalqa-detail-link');
      link.setAttribute('href', url);
      // ダイアログを開く
      let dialog_target = $(this).data('dialog-target-medicalqa');
      common.openDialog(dialog_target)
      return;

    } else if (medical_flg === 1) {
      window.location.href = url;
      return;
    }

    np_jp.lock();

    // ajaxでカート追加
    let item_id = $(this).data('item-id');
    $form = $('#form' + item_id);
    let serializeArrayData = $form.serializeArray();

    // 問診票の回答を取得
    for (let i = 1; i <= 15; i++) {
      let num = i.toString().padStart(2, '0')
      serializeArrayData.push({
        name: 'medical_answer_' + num,
        value: $('[name="select_medical_answer_' + num + '"]').val()
      });
    }

    $.ajax({
      url: $form.attr('action'),
      type: $form.attr('method'),
      data: serializeArrayData,
      dataType: 'json',
    }).done(function (data) {
      np_jp.unlock();
      console.log(data);
      // カートの上に表示される数量を更新
      let cart_amounts = $('.cart-amount');
      cart_amounts.each(function (index, element) {
        // カートが存在していなかった場合は非表示にしているため、表示
        $(element).css('display', '');
        // 総量をカートのバッジに代入
        $(element).html(data['total_amount']);
      });
      $.when(
        // ダイアログに値をセット
        setItemDataToDialog(data)
      ).done(
        //　ダイアログを表示
        $('#cart-add-dialog').fadeIn(500, function () {
          $(this).delay(3000).fadeOut("slow");
        })
      );
    })
  });

  let setItemDataToDialog = function (data) {
    // 商品画像URL
    let item_img = $('#dialog-item-image');
    $(item_img).attr('alt', data['item']['item_image_alt']);
    $(item_img).attr('src', data['item']['item_image_url']);

    // 販売元
    $('.cart-dialog-info .sales-agency').text(data['item']['sales_company_name']);

    // 商品名
    $('.cart-dialog-info .product-name').text(data['item']['item_name_site']);

    // 税抜金額
    $('.cart-dialog-info .base-price').text(data['item']['base_price'] + '円');

    // 税率
    $('.cart-dialog-info .tax-rate').text(data['item']['tax_rate']);

    // 税込金額
    let price = '';
    if (data['item']['bargain_class'] == 1) {
      price = data['item']['special_price'];
    } else if (data['item']['bargain_class'] == 0) {
      if (data['item']['bargain_assign_class'] == 1) {
        price = data['item']['bargain_assign_price'];
      } else if (data['item']['bargain_assign_class'] == 0) {
        price = data['item']['sales_price'];
      }
    }
    $('.cart-dialog-info .sales-price').text(price);

    // 税込金額
    $('.cart-dialog-info .amount').text(data['amount']);
  }
});
